import React from "react";
import "./Footer.css"

const Footer = () => {
  return (
    <>
    <div className="footerContainer">
      <a href="" target="_blank" rel="noreferrer" className="footerText">© 2022 PokeApp</a>
    </div>
    </>
  );
};

export default Footer;